module.exports = __webpack_public_path__ + "static/media/hero-image.bd136837.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero-image.png
// module id = 169
// module chunks = 0